import React, { useState } from "react";
import { Wrapper } from "./ExpensesTable.styled";
import { Button, Table, Modal, Popconfirm } from "components/common";
import { useHistory } from "react-router";
import {
  FileSearchOutlined,
  DeleteOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { getUserPermissions } from "utils/text";

const ExpensesTable = ({
  getExpenseData,
  expenseData,
  setIsOpen,
  isLoading,
  leadData,
  deleteExpense,
  userData,
  setEditData,
}) => {
  const history = useHistory();
  const columns = [
    {
      title: "Invoice Date",
      dataIndex: "invoiceDate",
      render: (text) => <a>{text}</a>,
      sorter: (a, b) => {
        let a_ = `${a.invoiceDate}`;
        let b_ = `${b.invoiceDate}`;
        if (a_ && b_) {
          return a_?.localeCompare(b_);
        } else {
          return 1;
        }
      },
    },
    {
      title: "Description",
      dataIndex: "description",
      render: (text) => <a>{text}</a>,
      sorter: (a, b) => {
        let a_ = `${a.description}`;
        let b_ = `${b.description}`;
        if (a_ && b_) {
          return a_?.localeCompare(b_);
        } else {
          return 1;
        }
      },
    },
    {
      title: "Category Name",
      render: (value) => {
        let statusValue = expenseData?.filter((el) => el.id == value?.category);
        return <span>{statusValue?.[0]?.name}</span>;
      },
      sorter: (a, b) => {
        let statusValuea = expenseData?.filter((el) => el.id == a?.category);
        let statusValueb = expenseData?.filter((el) => el.id == b?.category);

        let a_ = `${statusValuea?.[0]?.name}`;
        let b_ = `${statusValueb?.[0]?.name}`;
        if (a_ && b_) {
          return a_?.localeCompare(b_);
        } else {
          return 1;
        }
      },
    },
    {
      title: "Amount",
      dataIndex: "amount",
      render: (text) => <a>${text}</a>,
      sorter: (a, b) => {
        let a_ = `${a.amount}`;
        let b_ = `${b.amount}`;
        if (a_ && b_) {
          return a_?.localeCompare(b_);
        } else {
          return 1;
        }
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text) => {
        return <span>{text == true ? "Paid" : "Unpaid"}</span>;
      },
      sorter: (a, b) => {
        let a_ = `${a.status}`;
        let b_ = `${b.status}`;
        if (a_ && b_) {
          return a_?.localeCompare(b_);
        } else {
          return 1;
        }
      },
    },
    {
      title: "Lead",
      render: (value) => {
        let statusValue = leadData?.filter((el) => el.id == value?.leadId);
        return (
          <span>
            {statusValue?.[0]?.firstName} {statusValue?.[0]?.lastName}
          </span>
        );
      },
      sorter: (a, b) => {
        let statusValuea = leadData?.filter((el) => el.id == a?.leadId);
        let statusValueb = leadData?.filter((el) => el.id == b?.leadId);

        let a_ = `${statusValuea?.[0]?.firstName}`;
        let b_ = `${statusValueb?.[0]?.firstName}`;
        if (a_ && b_) {
          return a_?.localeCompare(b_);
        } else {
          return 1;
        }
      },
    },
    {
      title: "User",
      render: (value) => {
        let statusValue = userData?.filter(
          (el) => el.objectID == value?.userId
        );
        return <span>{statusValue?.[0]?.name}</span>;
      },
      sorter: (a, b) => {
        let statusValuea = userData?.filter((el) => el.objectID == a?.userId);
        let statusValueb = userData?.filter((el) => el.objectID == b?.userId);

        let a_ = `${statusValuea?.[0]?.name}`;
        let b_ = `${statusValueb?.[0]?.name}`;
        if (a_ && b_) {
          return a_?.localeCompare(b_);
        } else {
          return 1;
        }
      },
    },
    {
      title: "Action",

      render: (_, item) => (
        <a>
          {" "}
          <div>
            {getUserPermissions("edit-expense-action") && (
              <EditOutlined
                onClick={() => {
                  setIsOpen(true);
                  setEditData(item);
                }}
              />
            )}
            {getUserPermissions("delete-expense-action") && (
              <Popconfirm
                title="Are you sure you want to delete?"
                onConfirm={() => {
                  deleteExpense(item.id);
                }}
              >
                <DeleteOutlined className="delete-icon" />
              </Popconfirm>
            )}
            {getUserPermissions("expense-details-action") && (
              <FileSearchOutlined
                className="delete-icon"
                onClick={() => {
                  history.push(`/payment-expense/${item?.id}`);
                }}
              />
            )}
          </div>
        </a>
      ),
    },
  ];
  return (
    <Wrapper>
      <Table
        columns={columns}
        headerTitle="Expenses"
        header
        loading={isLoading}
        button
        dataSource={getExpenseData}
        button1={
          getUserPermissions("add-new-expense-action") && (
            <Button
              title="Add New Expense"
              AddIcon
              className="addButton"
              onClick={() => {
                setIsOpen(true);
                setEditData(null);
              }}
            />
          )
        }
      />
    </Wrapper>
  );
};

export default ExpensesTable;
